// libs
import React, { useState } from 'react';
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// components 
// ...
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function FormModal({loadapidata, apidataparams, setshowformmodalbox, orgaccountid, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        rowId: "",
        shippingPrice: "",
        isCod: "",
        isDefault: ""
    });
    const disabledField = (orginfo.roleId === 1 || orginfo.roleId === 2) ? false:true;
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' })
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm();

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false)
	}

    const updateChangeEvent = (value, field) => {
		field.onChange(value);
	}

    const handleInputState = ((key, val) => {
        const newData = { ...InputFields }
        newData[key] = val
        setInputFields(newData)
    })

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = {
            accountId: orgaccountid,
            rowId: rowid || 0,
            shippingPrice: data.shippingPrice,
            isCod: data.isCod,
            isDefault: data.isDefault
        }
        let apiCall = "";
        if(InputFields.rowId) {
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/shipping-price`, postData, token);
        } else {
            apiCall = await ajaxCall.postCall(`${config.api.generic}/shipping-price`, postData, token);
        }
        if(apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            loadapidata(apidataparams); // refresh list page
        } else {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    // Get data from DB - Used for Edit option
    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        async function fetchData() {
            if (rowid) {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/shipping-price/row`, {
                    rowId: (rowid) ? rowid : 0
                }, token);
                if(apiCall && apiCall.status) {
                    let onLoadData = {
                        accountId: orgaccountid,
                        rowId: rowid || 0,
                        shippingPrice: apiCall.context.message.data[0].shipping_price,
                        isCod: apiCall.context.message.data[0].is_cod,
                        isDefault: apiCall.context.message.data[0].is_default
                    }
                    setInputFields(onLoadData)
                    setNotification({ status: false })
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' })
                }
            }
        }
        fetchData();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{rowid?'Update Shipping Price':'Add Shipping Price'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Price Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Shipping Price</label>
                                            <input type="text" defaultValue={InputFields.shippingPrice} className="form-control" {...register("shippingPrice", { required: true, minLength: 1, maxLength: 5 })} disabled={disabledField} />
                                            <small className="form-text text-danger">
                                                {errors.shippingPrice?.type === "required" && "Shipping Price is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.shippingPrice?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.shippingPrice?.type === "maxLength" && "Only 5 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Is COD</label>
                                            <Controller
                                                name='isCod' 
                                                defaultValue={parseInt(InputFields.isCod)}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="isCod" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value="">Choose...</option>
                                                        <option value={0}>No</option>
                                                        <option value={1}>Yes</option>
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.isCod?.type === "required" && "Please update Is COD"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Is Default</label>
                                            <Controller
                                                name='isDefault' 
                                                defaultValue={parseInt(InputFields.isDefault)}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="isDefault" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value="">Choose...</option>
                                                        <option value={0}>No</option>
                                                        <option value={1}>Yes</option>
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.isDefault?.type === "required" && "Please update Is Default"}
                                            </small>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default FormModal;